import React, { useContext } from 'react';
import { ReloadOutlined } from '@ant-design/icons';
import {
  Button,
  Descriptions,
  Select,
  Skeleton,
  Space,
  Tooltip,
  Typography,
} from 'antd';
import dayjs from 'dayjs';

import BouncedEmailAccounts from '@totem/components/administration/bouncedEmails/details/BouncedEmailAccounts';
import BouncedEmailContactsTable from '@totem/components/administration/bouncedEmails/details/BouncedEmailContactsTable';
import BouncedEmailDetailsContext from '@totem/components/administration/bouncedEmails/details/BouncedEmailDetailsContext';
import BouncedEmailHistoryTable from '@totem/components/administration/bouncedEmails/details/BouncedEmailHistoryTable';
import { BOUNCED_EMAIL_STATUSES } from '@totem/components/administration/bouncedEmails/types';

const { Title } = Typography;

const DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';

export const BouncedEmailDetailsExtra = () => {
  const { onRefresh } = useContext(BouncedEmailDetailsContext);

  return (
    <Space>
      <Tooltip title="Refresh">
        <Button icon={<ReloadOutlined />} onClick={onRefresh} />
      </Tooltip>
    </Space>
  );
};

const BouncedEmailDetailsLayout = () => {
  const { loading, working, details, setStatus } = useContext(
    BouncedEmailDetailsContext,
  );

  if (loading && !details) {
    return <Skeleton active paragraph={{ rows: 6 }} />;
  }

  if (!details) {
    return null;
  }

  const { record } = details;

  return (
    <>
      <Descriptions
        column={{ xs: 1, md: 2 }}
        size="small"
        style={{ marginBottom: 16 }}
      >
        <Descriptions.Item label="Email">{record.email}</Descriptions.Item>
        <Descriptions.Item label="Status">
          <Select
            size="small"
            style={{ width: 160 }}
            value={record.status}
            disabled={working}
            onChange={setStatus}
            options={BOUNCED_EMAIL_STATUSES.map((status) => ({
              label: status,
              value: status,
            }))}
          />
        </Descriptions.Item>
        <Descriptions.Item label="Bounces">{record.count}</Descriptions.Item>
        <Descriptions.Item label="First Bounce">
          {dayjs(record.createdAt).format(DATE_TIME_FORMAT)}
        </Descriptions.Item>
        <Descriptions.Item label="Last Bounce">
          {dayjs(record.updatedAt).format(DATE_TIME_FORMAT)}
        </Descriptions.Item>
        <Descriptions.Item label="Last Reason" span={2}>
          {record.reason || '—'}
        </Descriptions.Item>
      </Descriptions>

      <Title level={5}>Contacts</Title>
      <BouncedEmailContactsTable />

      <Title level={5} style={{ marginTop: 16 }}>
        Accounts
      </Title>
      <BouncedEmailAccounts />

      <Title level={5} style={{ marginTop: 16 }}>
        History
      </Title>
      <BouncedEmailHistoryTable />
    </>
  );
};

export default BouncedEmailDetailsLayout;
